import type { DriveStep } from "driver.js";

function stepElementExists(step: DriveStep): boolean {
  const { element } = step;
  if (!element) return true;
  if (typeof element === "string") {
    return document.querySelector(element) !== null;
  }
  if (element instanceof Element) return document.body.contains(element);
  return true;
}

/** Schritte ohne sichtbares Ziel entfernen (z. B. Sidebar auf Mobilgeräten). */
export function filterVisibleSteps(steps: DriveStep[]): DriveStep[] {
  return steps.filter(stepElementExists);
}
